import React from "react";
import Typography from "@mui/material/Typography";
import { Link } from "@mui/material";

const SyaratKetentuanPageFooter = () => {
    const thisYear = new Date().getFullYear();

    return (
        <Typography
            variant="caption"
            component="div"
            textAlign="center"
            marginTop={5}
        >
            <Link
                variant="caption"
                target="_blank"
                href="https://nore.web.id/"
                underline="hover"
            >
                Nore Inovasi
            </Link>{" "}
            {`© ${thisYear}. All right reserved`}
        </Typography>
    );
};

export default SyaratKetentuanPageFooter;
